module.exports = __webpack_public_path__ + "static/media/copy_link_gray.3b55d2af.svg";